import { gadgetDefinitions } from '../game/content/gadgets';
import type { GadgetFailureNotice } from '../network/protocol';
import { itemSlotControl } from './ItemControls';

export interface GadgetFailureDescription {
  heading: string;
  copy: string;
  control: string;
}

export function describeGadgetFailure(failure: GadgetFailureNotice): GadgetFailureDescription {
  const control = itemSlotControl(failure.slot) ?? '?';
  const label = failure.itemId ? gadgetDefinitions[failure.itemId].label : 'ITEM';
  if (failure.reason === 'empty') {
    return {
      heading: `${control} SLOT EMPTY.`,
      copy: 'Walk over a glowing item supply to refill this slot.',
      control,
    };
  }
  if (failure.reason === 'cooldown') {
    return {
      heading: `${label} CYCLING.`,
      copy: `Wait for ${control} to return to READY before firing again.`,
      control,
    };
  }
  if (failure.reason === 'no_target' && failure.itemId === 'grapple') {
    return {
      heading: 'NO GRAPPLE LOCK.',
      copy: `Aim toward a roof anchor or the next car, then press ${control} again.`,
      control,
    };
  }
  if (failure.reason === 'no_target' && failure.itemId === 'magnet') {
    return {
      heading: 'NO MAGNETIC HAUL.',
      copy: `Aim at loose glowing salvage within range, then press ${control} again.`,
      control,
    };
  }
  return {
    heading: `${label} UNAVAILABLE.`,
    copy: `Check the ${control} slot and try again.`,
    control,
  };
}
